<template>
  <!-- out which, I am only applying Bootstrap to pages which use it -->

  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
    crossorigin="anonymous"
  />
  <!-- See: `getFullVh()` -->
  <div style="overflow: hidden; height: 0">
    <div id="measure-vh" style="position: fixed; height: 100vh"></div>
  </div>

  <div>
    <!-- how or dont show whole new home page -->

    <div
      class="container text-center"
      style="padding: 0vw; outline: 0em dashed orange"
    >
      <NavigationBar
        :loggedInUserDisplayname="this.loggedInUserDisplayname"
        :userImageDataComputed="this.userImageDataComputed"
        @do-order-badges="doOrderBadges"
        @do-show-home="doShowHome"
        @do-show-gettipsstart="doShowGetTipsStartNew"
        @do-show-givetips="doGiveTipsShowMoreInfoNew"
        @do-show-gettips="doGetTipsShowMoreInfoNew"
        @do-show-account="doShowAccount"
        @do-download-brochure="doDownloadBrochure"
        @do-show-contact="doShowContactNew"
      />

      <div
        class="jumbotron text-center tugradient1"
        style="outline: 0em dashed red"
      >
        <div class="container" style="padding: 3vw; outline: 0em dashed blue">
          <div class="row" style="outline: 0em dashed pink">
            <div
              class="col-sm-4 col-md-4 mainimageheight"
              style="outline: 0em dashed green"
            >
              <img
                class="mainimagewidth"
                style="
                  height: auto;
                  padding-top: 0vw;
                  outline: 0em dashed purple;
                "
                alt="Window sticker"
                src="../assets/hairdresser2.png"
              />
            </div>
            <!-- <div class="col-sm-8 col-md-8 text-start" style="padding-left: 3vw; padding-right: 6vw; outline:0.0em dashed orange; height: auto"> -->

            <div
              class="col-8 col-md-8 tufont tumediumtitlebold tubestsolutiontitle text-middle"
              style="outline: 0em dashed purple; height: auto"
            >
              Getting set up with thankU is this easy!
            </div>
            <HomePageTickedListItem
              ListItemString="Decide below which thankU QR media you would like"
            />
            <HomePageTickedListItem
              ListItemString="Click a 'Get set up for free!' button, for your media at no cost"
            />
            <HomePageTickedListItem
              ListItemString="Complete the email to tell us your selection and where to send the media"
            />
            <HomePageTickedListItem
              ListItemString="We send you your thankU QR media by post, and a staff set up email"
            />
            <HomePageTickedListItem
              ListItemString="Staff connect themselves to get ready for tips in 1 minute each"
            />
          </div>
          <br />

          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-start tusmallerfontsize"
            style="outline: 0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-10 offset-md-1 tufont;"
              style="outline: 0em dashed green"
            >
              <div
                class="bottombuttonwidth"
                style="padding-top: 1vh; margin: auto"
              >
                <span></span
                ><button
                  class="tuhomepagesignupbutton turegularfontsize"
                  style="width: 100%"
                  @click="this.doOrderBadges()"
                >
                  Get set up for free!
                </button>
              </div>
            </span>
          </div>
          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-center tusmallerfontsize"
            style="outline: 0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="padding-top: 1.5vw; outline: 0em dashed green"
            >
              thankU is currently providing its thankU QR badge media to you
              <b>free of charge</b> for a limited time only. Simply tell us how
              many of each format you would like, and the address to send them
              to - that's it!
            </span>
          </div>
          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-center tusmallerfontsize"
            style="outline: 0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="padding-top: 1.5vw; outline: 0em dashed green"
            >
              If one of our standard packages below does not suit your needs,
              simply let us know your requirements.
            </span>
          </div>
        </div>

        <div class="container" style="padding-top: 1vw">
          <div class="row">
            <div class="col-md-12 tuwhitebox">
              <div class="tufont tumediumtitlebold">Regular package</div>
              <div
                class="col-md-8 offset-md-2 tufont tusmallerfontsize"
                style="padding-top: 1vw; padding-bottom: 1vw"
              >
                This package is widely used in salons, however we have a number
                of options other than 'stylist', including 'therapist',
                'technician', 'artist', 'host', 'waiter', 'driver', 'team', or
                non-specific.
              </div>
              <div
                class="container"
                style="
                  display: flex;
                  flex-wrap: wrap;
                  outline: 0em dashed green;
                "
              >
                <div class="col-12 col-md-6" style="outline: 0em dashed pink">
                  <table
                    class="table"
                    border="0"
                    style="width: 100%; outline: 0em dashed red"
                  >
                    <tr>
                      <td
                        style="padding-bottom: 0.2vw; outline: 0em dashed pink"
                      >
                        Front Desk Stand
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0em dashed brown"
                        >
                          Typically placed at your reception / payments desk,
                          our stylish Front Desk Stand announces to your clients
                          that you have a tipping service available for them.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <img
                          class="mainimagewidth"
                          style="
                            width: 500px;
                            height: auto;
                            padding-top: 0vw;
                            outline: 0em dashed purple;
                          "
                          alt="Window sticker"
                          src="../assets/frontdeskrounded.webp"
                        />
                      </td>
                    </tr>
                  </table>
                </div>

                <div class="col-12 col-md-6" style="outline: 0em dashed red">
                  <table
                    class="table"
                    border="0"
                    style="width: 100%; outline: 0em dashed red"
                  >
                    <tr>
                      <td
                        style="padding-bottom: 0.2vw; outline: 0em dashed pink"
                      >
                        <b>Optional:</b> "No glue" mirror sticker
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0em dashed brown"
                        >
                          <b>At your option:</b> mount our "No glue" mirror
                          stickers on the mirror in front of the client. Some
                          salons choose this option, others do not, it's a
                          matter of personal preference.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <img
                          class="mainimagewidth"
                          style="
                            width: 500px;
                            height: auto;
                            padding-top: 0vw;
                            outline: 0em dashed purple;
                          "
                          alt="Window sticker"
                          src="../assets/stickerrounded.webp"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0em dashed brown"
                        >
                          <b>How to mount:</b> adheres to the surface of
                          client-facing mirror without adhesive and is easily
                          removable – simply moisten glass of mirror with damp
                          kitchen roll or similar, then mount the ‘sticker’ on
                          the glass, gently pressing out any obvious bubbles
                          with your finger – dab any remaining moisture on the
                          surface of the sticker or mirror away if necessary.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0em dashed brown"
                        >
                          <b
                            >We also have wearable and stickable thankU QR
                            media, please phone or email us to find out more.</b
                          >
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
            <div
              class="col-md-6 offset-md-2 tuwhitebox"
              style="margin-top: 3vw; padding-top: 1vw"
            >
              <div class="tufont tumediumtitlebold" style="padding-bottom: 1vw">
                Discrete package
              </div>

              <div class="container">
                <div class="col-12 col-md-12" style="outline: 0em dashed red">
                  <table
                    border="0"
                    style="width: 100%; outline: 0em dashed red"
                  >
                    <tr>
                      <td style="padding-bottom: 1vw">Tabletop Stand</td>
                    </tr>

                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0em dashed brown"
                        >
                          If you just want to keep the presentation of thankU
                          very discreet, use our sleek Tabletop Stand instead of
                          the Front Desk Stand, which you can direct your
                          clients to if they ask how they can tip.
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <img
                          class="mainimagewidth"
                          style="
                            width: 300px;
                            height: auto;
                            padding-top: 0vw;
                            outline: 0em dashed purple;
                          "
                          alt="Window sticker"
                          src="../assets/countersquare.webp"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0em dashed brown"
                        >
                          We supply up to 3 Tabletop Stands at no charge.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 0.3vw;
                          padding-bottom: 1vw;
                          outline: 0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0em dashed brown"
                        >
                          <b
                            >We also have wearable and stickable thankU QR
                            media, based on the blue thankU QR badge shown above
                            - please phone or email us to find out more.</b
                          >
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 offset-md-2 tugreybluebox" style="margin-top: 3vw">
          <table style="width: 100%">
            <tr>
              <td>
                <div class="tufont tumediumtitlebold">
                  Order your free thankU QR media
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0em dashed red;
                  "
                >
                  <span
                    class="col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="standard-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="displayname-signup"
                      placeholder="Your name"
                      @change="doDetectSelectChange()"
                    >
                     <option value="regular">
                        -- Choose thankU QR media package --
                        </option>
                      <option value="regular">
                        Regular thankU QR media package
                      </option>
                      <option value="discreet">
                        Discreet thankU QR media package
                      </option>
                      <option value="custom">
                        Custom - tell us in the Notes box below
                      </option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0em dashed red;
                  "
                >
                  <span
                    class="col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="standard-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="displayname-signup"
                      placeholder="Your name"
                      @change="doDetectSelectChange()"
                    >
                      <option value="regular">
                        -- Select your business type--
                      </option>
                      <option value="regular">
                        Salon
                      </option>
                      <option value="custom">
                        Hotel 
                      </option>
                      <option value="discreet">
                        Restaurant
                      </option>
                      <option value="custom">
                        Pub 
                      </option>
                       <option value="custom">
                        Other
                      </option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0em dashed red;
                  "
                >
                  <span
                    class="col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="standard-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="displayname-signup"
                      placeholder="Your name"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0em dashed red;
                  "
                >
                  <span
                    class="col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="standard-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="displayname-signup"
                      placeholder="Name of your business"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0em dashed red;
                  "
                >
                  <span
                    class="col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="standard-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="displayname-signup"
                      placeholder="Address to send your thankU QR media package to"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td style="display: flex">
                <div
                  class="lt-blue notes-text"
                  style="width: 60%; padding-top: 0vw; line-height: 1px"
                >
                  Your email address is never shared with anyone
                </div>
                <br />
              </td>
            </tr>
            <tr>
              <td>
                <div style="height: 6vh; display: flex">
                  <input
                    type="email"
                    class="standard-textbox input"
                    ref="email-signup"
                    placeholder="email"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td style="display: flex">
                <div class="lt-blue notes-text" style="width: 60%">
                  Your email address is never shared with anyone
                </div>
                <br />
              </td>
            </tr>
            Have anby questions? Email us at OR call us on 020 77777 7 7
            <tr>
              <td style="height: 12vh">
                <div>
                  <button
                    class="widebtn"
                    style="width: 50%; height: 5vh"
                    @click="this.doSignUpDB()"
                  >
                    Sign Up
                  </button>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="mediaSelectDesktop">
          <div class="container" style="padding: 3vw; outline: 0em dashed blue">
            <div class="row" style="outline: 0em dashed pink"></div>
          </div>
          <div class="row" style="height: 1vw">
            <div class="col-sm-4 col-md-1" style="outline: 0em dashed green">
              <img
                class="smile1"
                alt="thankU smile right"
                src="../assets/tusmileonly.png"
              />
            </div>
            <div class="col-sm-4 col-md-1" style="outline: 0em dashed green">
              <img
                class="smile2"
                alt="thankU smile right"
                src="../assets/tusmileonly.png"
              />
            </div>
          </div>
        </div>
        <div class="mediaSelectPhone container">
          <div class="row" style="outline: 0em dashed pink">
            <div
              class="col-10 offset-1 text-md-start highestratedpadding"
              style="
                padding-left: 3vw;
                padding-right: 6vw;
                padding-top: 7vw;
                outline: 0em dashed orange;
                height: auto;
              "
            ></div>
            <div
              class="col-10 offset-1 text-md-start highestratedpadding tufont tumediumtitlebold tublue"
              style="
                padding-left: 3vw;
                padding-right: 6vw;
                outline: 0em dashed orange;
                height: auto;
              "
            ></div>

            <div
              class="offset-0 col-3"
              style="height: 0px; outline: 0em dashed green"
            >
              <img
                class="smile1"
                alt="thankU smile"
                src="../assets/tusmileonly.png"
              />
            </div>

            <div>&nbsp;</div>

            <div
              class="offset-0 col-12 float-right"
              style="height: 0px; outline: 0em dashed green"
            >
              <img
                class="smile2"
                alt="thankU smile"
                src="../assets/tusmileonly.png"
              />
            </div>
            <div>&nbsp;</div>
            <div
              class="col-10 offset-1 tufont turegularfontsize maintextpadding"
              style="outline: 0em dashed blue"
            ></div>
            <div
              class="col-10 offset-1 text-start tufont turegularfontsize maintextpadding"
            ></div>
            <div
              class="col-10 offset-1 tufont turegularfontsize"
              style="padding-bottom: 4vw"
            >
              <button
                class="tuhomepagesignupbutton"
                @click="this.doOrderBadges()"
              >
                Get set up for free!
              </button>
            </div>
            <div
              class="col-10 offset-1 text-start tufont turegularfontsize maintextpadding"
            ></div>
          </div>
        </div>
      </div>
      <br />
      <HomeFooter
        @do-show-contact="doShowContactNew"
        @do-show-about="doShowAboutNew"
        @do-show-privacy="doShowPrivacyNew"
        @do-show-terms="doShowTermsNew"
      />
    </div>
  </div>
  <div
    v-if="false === true"
    class="topcontent-div"
    style="width: 100%; height: 100%; outline: 0em solid black"
  >
    <!-- not sure why but the height: 100% allows modal to center in the page otherwise it goes to top -->
    <div class="wrapper-todiv" style="padding-top: 5vh; padding-bottom: 5vh">
      <table
        width="100%"
        border="0"
        style="padding-left: 2.5vh; padding-right: 2.5vh"
      >
        <tr>
          <td>
            <table width="100%" border="0" s>
              <tr>
                <td width="30%">
                  <span
                    class="primary-general-text divl"
                    style="display: block; line-height: 15px"
                  ></span>
                </td>
                <td width="40%">
                  <img
                    class="tulogo"
                    style="height: 6vh; padding-bottom: 1vh"
                    alt="thankU logo"
                    src="../assets/tutxtlogo.png"
                  />
                </td>
                <td width="30%">
                  <div class="divr">
                    <button
                      @click="this.goBack()"
                      class="text-only-button cancel"
                    >
                      <img
                        class="tulogo"
                        style="height: 4vh"
                        alt="close"
                        src="../assets/greycross.png"
                      />
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td style="padding-top: 1vh; padding-bottom: 1vh; line-height: 0.1px">
            <span
              class="lt-blue"
              :style="{
                'font-size': fontSizeNormalInPXToUse + 'px',
                'line-height': fontSizeNormalInPXLineHeightToUse + 'px',
              }"
              v-if="this.nhbfmembers === true"
              >Welcome NHBF members!
              <p></p
            ></span>
            <span
              class="lt-blue"
              :style="{
                'font-size': fontSizeNormalInPXToUse + 'px',
                'line-height': fontSizeNormalInPXLineHeightToUse + 'px',
              }"
              ><span
                style="
                  font-size: 13.5pt;
                  font-family: 'Arial', sans-serif;
                  color: rgb(94, 144, 227);
                "
                ><b>Get your FR3EE thankU badges</b></span
              ></span
            >
          </td>
        </tr>

        <tr style="cursor: pointer">
          <td @click="doDownloadBrochure()" style="cursor: pointer">
            <a href="https://www.thanku.app/introtothanku.pdf"
              ><img
                style="width: 100%; cursor: pointer"
                alt="cashless tipping"
                src="../assets/introcover.jpg"
            /></a>
          </td>
        </tr>
        <tr>
          <td
            @click="doDownloadBrochure()"
            style="
              cursor: pointer;
              padding-top: 1vh;
              padding-bottom: 1vh;
              line-height: 0.1px;
            "
          >
            <span
              class="lt-blue"
              :style="{
                'font-size': fontSizeNormalInPXToUse + 'px',
                'line-height': fontSizeNormalInPXLineHeightToUse + 'px',
              }"
              ><span
                style="
                  padding-top: 25vh;
                  font-size: 13.5pt;
                  font-family: 'Arial', sans-serif;
                  color: rgb(94, 144, 227);
                "
                ><b
                  ><u
                    ><a
                      href="https://www.thanku.app/introtothanku.pdf"
                      target="_self"
                      >Download our brochure</a
                    ></u
                  ></b
                ></span
              ></span
            >
          </td>
        </tr>

        <tr>
          <td colspan="3" style="padding-top: clamp(2px, 2vh, 18px)">
            <div
              class="userinfoframe actionbtn-div notesInfoTextLarger"
              style="
                padding-bottom: clamp(1px, 1vh, 8px);
                padding-top: clamp(1px, 1vh, 8px);
              "
            >
              <table>
                <tr>
                  <td
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: clamp(1px, 1vh, 8px);
                      padding-bottom: clamp(2px, 3vh, 24px);
                    "
                  >
                    thankU is currently providing its thankU QR badge media to
                    you free of charge for a limited time only.
                    <p></p>
                    Simply tap the 'Order thankU badges' button below after
                    reviewing the following badge media options and tell us how
                    many of each format you would like, and the address to send
                    them to - that's it!
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: clamp(1px, 1vh, 8px);
                      padding-bottom: clamp(2px, 3vh, 24px);
                    "
                  >
                    thankU is available at <b>no cost to businesses</b> - fees
                    are payable on tip transactions, most often paid by the
                    tipper, but when not, fees are deducted from the tip. For
                    FAQ on recieving tips, please see
                    <span
                      class="text-only-button cancel"
                      @click="doGetTipsShowMoreInfo()"
                      style="pointer: cursor"
                      ><b>here</b></span
                    >, and specifically on fees, please see
                    <span
                      class="text-only-button cancel"
                      @click="doGetTipsShowMoreInfoFees()"
                      style="pointer: cursor"
                      ><b>here</b></span
                    >.
                  </td>
                </tr>
                <tr>
                  <td colspan="3" style="padding-top: clamp(1px, 1vh, 8px)">
                    <b
                      ><span
                        style="
                          font-size: 13.5pt;
                          font-family: 'Arial', sans-serif;
                          color: rgb(94, 144, 227);
                        "
                        >Front Desk Stand</span
                      ></b
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: clamp(1px, 1vh, 8px);
                      padding-bottom: clamp(2px, 3vh, 24px);
                    "
                  >
                    As a starting point, we supply you with one of our Front
                    Desk Stands which introduces thankU to your clients and then
                    you have a choice between the two options further below -
                    7.4 x 10.5cm.
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="3"
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: 0vh;
                    "
                  >
                    <img
                      style="width: 85%; cursor: pointer"
                      alt="thankU cashless tipping app"
                      src="../assets/pos2croppedsm.webp"
                    />
                  </td>
                </tr>
                <br />
                <tr>
                  <td colspan="3" style="padding-top: clamp(1px, 1vh, 8px)">
                    <b
                      ><span
                        style="
                          font-size: 13.5pt;
                          font-family: 'Arial', sans-serif;
                          color: rgb(94, 144, 227);
                        "
                        >Option 1: Tabletop Stand</span
                      ></b
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: clamp(1px, 1vh, 8px);
                      padding-bottom: clamp(2px, 3vh, 24px);
                    "
                  >
                    ..goes on the tabletop in front of the client at their seat
                    - a discreet choice: the client might ask "what's that?" and
                    your stylist replies "We have clients who asked us for
                    cashless tipping and this is it".. 6 x 4.3cm.
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="3"
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: 0vh;
                    "
                  >
                    <img
                      style="width: 85%; cursor: pointer"
                      alt="thankU cashless tipping app"
                      src="../assets/countersquaresm.webp"
                    />
                  </td>
                </tr>
                <br />
                <tr>
                  <td colspan="3" style="padding-top: clamp(1px, 1vh, 8px)">
                    <b
                      ><span
                        style="
                          font-size: 13.5pt;
                          font-family: 'Arial', sans-serif;
                          color: rgb(94, 144, 227);
                        "
                        >Option 2: ‘No Glue’ Mirror Sticker</span
                      ></b
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: clamp(1px, 1vh, 8px);
                      padding-bottom: clamp(2px, 3vh, 24px);
                    "
                  >
                    simply mount on mirror facing client for a little more
                    impact - no glue, can be easily removed - 12cm x 8cm.
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="3"
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: 0vh;
                    "
                  >
                    <img
                      style="width: 85%; cursor: pointer"
                      alt="thankU cashless tipping app"
                      src="../assets/staticcling.png"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: clamp(2px, 2vh, 18px);
                      padding-right: clamp(2px, 2vh, 18px);
                      padding-top: clamp(2px, 3vh, 24px);
                      padding-bottom: clamp(2px, 3vh, 24px);
                    "
                  >
                    We have thankU QR media in other formats, such as wristworn
                    for businesses such as hotels - please enquire with the
                    'Order thankU badges' button below.
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="actionbtn-div" style="padding-top: 1vh">
                      <span
                        class="lt-blue"
                        :style="{
                          'font-size': fontSizeNormalInPXToUse * 0.9 + 'px',
                          'line-height':
                            fontSizeNormalInPXLineHeightToUse * 0.9 + 'px',
                        }"
                      ></span
                      ><button
                        class="widebtn"
                        style="width: 100%; height: 7vh"
                        @click="this.doOrderBadges()"
                      >
                        Order thankU badges
                      </button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
const Parse = require("parse/node");
import shared from "../shared.js";
import LogRocket from "logrocket";

import { defineAsyncComponent } from "vue";

const NavigationBar = defineAsyncComponent({
  loader: () => import("../components/NavigationBar.vue"),
});

const HomePageTickedListItem = defineAsyncComponent({
  loader: () => import("../components/HomePageTickedListItem.vue"),
});

const HomeFooter = defineAsyncComponent({
  loader: () => import("../components/HomeFooter.vue"),
});

export default {
  inject: ["globalPushForwardInterval", "devEnv", "appId", "appJSKey"],
  data() {
    return {
      popUpMsgTitle: "",
      popUpMsgBody: "",
      showPopUpOk: false,
      fontSizeTitle: 2.7, // vh
      fontSizeTitleLineHeight: 5, //vh
      fontSizePopUpMsg: 2.3, // vh
      fontSizePopUpMsgLineHeight: 3.4, // vh

      fontSizeNormal: 3.0, // vh
      fontSizeNormalInPXToUse: "",
      fontSizeNormalLineHeight: 4.0, // vh
      fontSizeNormalInPXLineHeightToUse: "",
      nhbfmembers: false,
    };
  },
  components: {
    NavigationBar,
    HomePageTickedListItem,
    HomeFooter,
  },
  methods: {
    doFontSizeComputed() {
      this.fontSizeNormalInPXToUse = shared.convertVHSizeToMaxPixelsSize(
        this.fontSizeNormal,
        16
      );
      this.fontSizeNormalInPXLineHeightToUse =
        shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormalLineHeight, 20);
    },
    doOrderBadges() {
      // const url = "mailto:mailorders@thanku.app?subject=get thankU enquiry&body=Please tell us a little about your business so we can send you the right quantity and best suited thankU QR badge media for you - for example, if you own or manage a hair salon, please tell us how many stylist seats you have.. Please also supply the address we should dispatch your thankU media to. If you manage a hotel or a car valet business, we supply the thankU QR badge media mounted on wristbands - let us know and we will send you images and agree staff quantities. All thankU QR badge media is supplied free of charge."

      let url =
        "mailto:mailorders@thanku.app?subject=get thankU enquiry&body=Please fill out below - we will email you back to confirm your order and let you know if we need any further information before dispatching it - please respond below:%0D%0A%0D%0AWhat is your business name?%0D%0A%0D%0AAre you a salon? If not, what type of business please?                  %0D%0A%0D%0AWould you like our our 'No Glue' Mirror Stickers option in addition to your Front Desk Stand? If so, how many stickers would you like? (if a salon, we suggest one for every client seat mirror)    %0D%0A%0D%0AOr - instead - woudl like to receive just our super discreet Tabletop Stand? and if yes, how many would you like?                  %0D%0A%0D%0AIf you are not a salon and would like different QR media (e.g. wearables), let us know and we will email you to ask a bit more about your business..                  %0D%0A%0D%0AWhich address should send we send your thankU QR media to?                  %0D%0A%0D%0A%0D%0AThank you! best wishes, the thankU Team";

      // console.log("tapped get free thankU badges button on GET TIPS START");
      const params = {
        toEmail: "appalert@thanku.app",
        subject:
          "GREAT! Someone tapped get free thankU badges button on GET TIPS START",
        body: "",
      };

      Parse.Cloud.run("sendEmail", params);
      window.open(url, "_self");

      this.goBack();
    },
    doDownloadBrochure() {
      const url = "https://www.thanku.app/introtothanku.pdf";
      // console.log("opening pdf");
      const params = {
        toEmail: "appalert@thanku.app",
        subject: "GREAT! Someone downloaded thankU pdf brochure",
        body: "",
      };

      Parse.Cloud.run("sendEmail", params);
      window.open(url, "_self");
    },
    doShowHolding() {
      shared.saveToUserPath(
        this.devEnv,
        "User wanted to start get tips process " + new Date().toISOString(),
        this.globalPushForwardInterval
      );
      this.popUpMsgTitle = "Sorry";
      this.popUpMsgBody =
        "This bit is not ready yet - for the time being please just email us at mediaorders@thanku.app and let us know what type of business you have and how many people will receive tips at it";
      this.showPopUpOk = true;
    },
    doRecipientSelected() {
      //this.$router.back();

      let returnJSON = {
        selectedTUID: "00000000002",
      };

      this.$emit("return-json", returnJSON);
    },
    doGetTipsShowMoreInfo() {
      // /console.log("show more info!");

      let returnJSON = { showMoreGetInfo: true };
      this.$emit("return-json", returnJSON);
    },
    doGetTipsShowMoreInfoFees() {
      // /console.log("show more info!");

      let returnJSON = { showMoreGetInfo: true, feesShow: true };
      this.$emit("return-json", returnJSON);
    },
    goBack() {
      // console.log("we're off! Next screen is " + window.localStorage.getItem("nextScreen"));
      if (window.localStorage.getItem("nextScreen") !== null) {
        let returnJSON = {
          nextScreen: window.localStorage.getItem("nextScreen"),
        };
        this.$emit("return-json", returnJSON);
        window.localStorage.removeItem("nextScreen");
      } else {
        let returnJSON = { showHome: true };
        this.$emit("return-json", returnJSON);
      }
    },
    doSetMetas() {
      document.title = "Get free thankU cashless tipping QR badges";
      document
        .getElementsByTagName("meta")
        .namedItem("description")
        .setAttribute(
          "content",
          "Get free thankU cashless tipping QR badges - our stand-mounted thankU QR badges are just 6x4x2cm. They sit at the front desk and at your client seats (at your option). Simply tap the 'Order thankU badges' button below, tell us which design/colour you like (1, 2, or 3), how many you need, and the address to send them to - that's it!"
        );
    },
    async deployLogRocket() {
      var LRObjectId = new Date().getTime();

      if (window.localStorage.getItem("tuob") !== null) {
        LRObjectId = window.localStorage.getItem("tuob");
      }

      if (LRObjectId === "4g278vWUb1" || LRObjectId === "2fBkimFcIw") {
        return; // don't record myself
      }

      var LRDisplayname = "LR Name not given";

      if (window.localStorage.getItem("tudis") !== null) {
        LRDisplayname = window.localStorage.getItem("tudis");
      }

      try {
        LogRocket.init('fpi3vr/thanku');  //LogRocket.init("thanku-alt-7/thanku-alt-7"); //LogRocket.init('thanku-alt-6/thanku-alt-6'); //LogRocket.init('thanku-alt/tualt'); //LogRocket.init('thanku-alt-4/thanku-alt-4'); //LogRocket.init('thanku-alt-3/thanku-alt-3');//LogRocket.init('thanku-alt-5/thanku-alt-5'); //  LogRocket.init('thanku-alt-2/thanku-alt-2');//
        LogRocket.identify(LRObjectId, {
          name: LRDisplayname + ": get started",
          email: undefined,
          // Add your own custom user variables here, ie:
        });
      } catch (e) {
        // console.log("error starting LogRocket tipper id: " + this.tipper.objectId);

        const params = {
          toEmail: "appalert@thanku.app",
          subject: "ALERT! LogRocket initialisation error: " + e.message,
          body: "ALERT! LogRocket initialisation error: " + e.message,
        };

        Parse.Cloud.run("sendEmail", params);
        // fail silently do nothing
      }
    },
  },
  created() {
    this.deployLogRocket();
    document.body.style.maxWidth = "100vw"; // for Google mobile crawler had to limit homepage width on body tag, this resets it
    this.doSetMetas();
    // console.log("Get Tips Start created");
    // console.log("window query: " + JSON.stringify(this.$route.params, null, 2));

    const fromScreen =
      this.$route.params !== undefined
        ? " from " + this.$route.params.fromScreen
        : this.fromScreen !== undefined
        ? this.fromScreen
        : "";

    let referrerURL =
      window.localStorage.getItem("referrerURL") !== null
        ? window.localStorage.getItem("referrerURL")
        : "";

    // console.log("MY REFERRERURL on GetTipsStart IS: " + referrerURL);

    shared.sendAppAlert(
      "Great! Someone has tapped the get tips button" + fromScreen + "!",
      referrerURL,
      this.appId,
      this.appJSKey
    );

    var extraMsg = "";

    if (window.localStorage.getItem("isnhbfmember") !== null) {
      // /console.log("this IS an NHBF member");
      window.localStorage.removeItem("isnhbfmember");
      this.nhbfmembers = true;
      extraMsg = "FOR NHBF MEMBER ";
    }
    shared.saveToUserPath(
      this.devEnv,
      "Get tips start process " + extraMsg + new Date().toISOString(),
      this.globalPushForwardInterval
    );
    this.doFontSizeComputed();
    window.addEventListener("resize", this.doFontSizeComputed);
  },
  mounted() {
    // console.log("MOUNTME!");
    window.scrollTo(0, 0);
  },
};
</script>

